export default {
  common: {
    appName: "Flash Cards",
    tagline: "Master mental math, one flash at a time",
    startTraining: "Start Training",
    stop: "Stop",
    save: "Save",
    reset: "Reset",
    clear: "Clear",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    backToHome: "Back to Home"
  },
  navigation: {
    flashCalculation: "Flash Calculation",
    history: "History",
    settings: "Settings",
    tryTheApp: "Try the App"
  },
  landing: {
    hero: {
      title: "Train your mental math reflexes",
      subtitle:
        "Build lightning-fast number sense with abacus-inspired flash drills. Fun, focused, and effective—especially for kids and students.",
      startTraining: "Start Training",
      learnMore: "Learn More"
    },
    whyAbacus: {
      title: "Why abacus-based learning?",
      description:
        "The abacus has helped learners for centuries—not only to calculate, but to think in numbers. Practicing with abacus-style flashes builds attention, working memory, and number sense. It's a playful path to confident mental math, especially for children.",
      focus: {
        title: "Focus",
        description: "Short bursts build sustained attention and concentration skills."
      },
      speed: {
        title: "Speed",
        description: "Rapid drills strengthen recall and mental agility."
      },
      numberSense: {
        title: "Number Sense",
        description: "See patterns and relationships, not just individual digits."
      },
      confidence: {
        title: "Confidence",
        description:
          "Small wins add up to mathematical mastery and self-assurance."
      }
    },
    history: {
      title: "Abacus in Japan: From Suanpan to Modern Soroban",
      description:
        "Discover the fascinating journey of the abacus through Japanese history and its evolution into a powerful cognitive training tool.",
      origins: {
        title: "Origins & Spread",
        description:
          "The abacus reached Japan from China (suanpan), likely via Korea as early as the 14th century; its use became widespread during the Edo period (1603–1867)."
      },
      simplification: {
        title: "Instrument Simplification",
        description:
          "From the Chinese 2/5 layout (two upper beads, five lower), the Japanese first adopted a 1/5 layout and later the modern 1/4 configuration, standardized in 1938—faster and more efficient for decimal calculation."
      },
      keyFigure: {
        title: "Key Figure",
        description:
          "The mathematician Seki Kōwa (17th century) studied the soroban and its methods extensively, helping disseminate techniques and instruction."
      },
      iconicMoment: {
        title: "An Iconic Moment",
        description:
          "On November 12, 1946, in Tokyo, a contest pitted a soroban master against a U.S. serviceman using an electronic calculator. The soroban won four out of five rounds—dramatically showcasing its speed and accuracy."
      },
      flashAnzan: {
        title: "Flash Anzan",
        description:
          'In addition to traditional competitions, Japan hosts "Flash Anzan" events where numbers appear rapidly on a screen and are computed mentally by visualizing bead movements. Records demonstrate remarkable processing speed.'
      },
      educationToday: {
        title: "Education Today",
        description:
          "Though not mandatory everywhere, the soroban remains part of the curriculum in some elementary schools and training centers because it develops focus, working memory, and number sense—especially in children."
      },
      quote:
        "The soroban bridges tradition and modern cognitive training: a simple tool that builds confidence and rapid calculation skills."
    },
    howItWorks: {
      title: "How Flash Cards Works",
      step1: {
        title: "Pick your pace",
        description:
          "Choose digits, speed, and how many flashes to show. Customize your training experience."
      },
      step2: {
        title: "Watch & compute",
        description:
          "Numbers appear briefly—track them mentally, abacus-style. Build your mental calculation skills."
      },
      step3: {
        title: "Check results",
        description:
          "Reveal the sum and see your progress over time. Track your improvement journey."
      },
      tryItNow: "Try it now"
    },
    cta: {
      title: "Ready to sharpen your mental math?",
      description:
        "Join thousands of students and teachers who use Flash Cards to build faster, more confident mental arithmetic skills.",
      startTrainingNow: "Start Training Now"
    }
  },
  flashCalculation: {
    title: "Flash Calculation Training",
    status: {
      active: "Active",
      readyToStart: "to start"
    },
    progress: {
      currentNumber: "Current number",
      total: "Total"
    },
    result: {
      title: "Result",
      sequence: "Sequence",
      sum: "Sum",
      showResult: "Show Result",
      numberSequence: "Number Sequence:",
      total: "Total:",
      successMessage: "Great job! You've completed the calculation successfully."
    },
    idle: {
      title: "Flash Calculation Training",
      subtitle: "Click \"Start\" to begin training"
    }
  },
  settings: {
    title: "Settings",
    flashCalculation: {
      title: "Flash Calculation",
      digitLength: "Digit Length",
      numberOfDisplays: "Number of Displays",
      speed: "Speed",
      editSpeed: "Edit Speed",
      showingMinusNumbers: "Showing Minus Numbers",
      showingDecimalNumbers: "Showing Decimal Numbers",
      decimalLength: "Decimal Length",
      fontSize: "Font Size",
      enableAudio: "Enable Audio",
      saveSettings: "Save Settings",
      resetSettings: "Reset Settings"
    },
    speed: {
      slowest: "Slowest",
      slow: "Slow",
      normal: "Normal",
      fast: "Fast",
      fastest: "Fastest"
    }
  },
  history: {
    title: "Training History",
    subtitle: "Track your progress and improvement",
    noHistory: "No History Yet",
    noHistoryDescription:
      "Complete some training sessions to see your progress here!",
    totalSessions: "Total Sessions",
    clearHistory: "Clear History",
    clearHistoryConfirm:
      "Are you sure you want to clear all history? This action cannot be undone.",
    clearAll: "Clear All",
    numbers: "numbers",
    deleteEntry: "Delete Entry"
  },
  footer: {
    builtFor: "Built for better mental math",
    developedBy: "Developed by",
    copyright:
      "Train your mind, one flash at a time."
  }
};
